import { AlertColor, Grid, Typography } from '@mui/material';
import queryString from 'query-string';
import { useContext, useState } from 'react';
import { Redirect } from 'react-router';

import { changePasswordWithToken } from '../../../../api/api';
import PasswordRequirements from '../../../../components/Atoms/CustomMessage/PasswordRequirements';
import { SimpleAlert } from '../../../../components/Atoms/SimpleAlert';
import DevelopedBySection from '../../../../components/LayoutAuth/DevelopedBySection';
import PasswordForm from '../../../../components/LayoutAuth/Forms/PasswordForm';
import HeaderLogo from '../../../../components/LayoutAuth/HeaderLogo';
import HelpSection from '../../../../components/LayoutAuth/HelpSection';
import { LOGIN, RESET_PASSWORD } from '../../../../constants/routes';
import BusinessUnitParamsContext from '../../../../contexts/BusinessUnitParamsContext/businessUnitParamsContext';
import { useStyles } from '../../../../styles/global/stylesLogin';
import { isValidPassword } from '../../../../util/commons';
import { setSessionInfo } from '../../../../util/LocalStorage/login';
import { getEmailToResetPassword } from '../../../../util/LocalStorage/resetPassword';
import TokenNotValidForm from '../../ActivateAccount/TokenNotValid/TokenNotValidForm';

type FormInputs = {
  email: string;
  password: string;
  confirmPassword: string;
};

const ChangePasswordForm = () => {
  const { token } = queryString.parse(location.search);
  const { businessUnitUUID } = useContext(BusinessUnitParamsContext);
  const classes = useStyles();

  const [showAlert, setShowAlert] = useState(false);
  const [showInputError, setShowInputError] = useState(false);
  const [alertType, setAlertType] = useState<AlertColor>('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [unauthorized, setUnauthorized] = useState(false);
  const emailToResetPassword = getEmailToResetPassword();

  const onSubmit = async (data: FormInputs) => {
    setShowAlert(false);
    setShowInputError(false);
    if (data.password != '' && data.confirmPassword != '') {
      try {
        if (data.password && isValidPassword(data.password)) {
          if (data.password === data.confirmPassword) {
            const response = await changePasswordWithToken(token, businessUnitUUID, data.password);
            setSessionInfo(response, businessUnitUUID);
            setTimeout(() => {
              location.reload();
            }, 1000);
          } else {
            setMessageError('Las contraseñas no coinciden. Inténtalo nuevamente');
          }
        } else {
          setShowInputError(true);
          setMessageError(<PasswordRequirements />);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          setUnauthorized(true);
        } else {
          setMessageError(error.response.data.message);
          console.error(error);
        }
      }
    }
  };

  const setMessageError = (message: any) => {
    setShowAlert(true);
    setAlertType('error');
    setAlertMessage(message);
  };

  const onError = () => {
    console.error('onError');
  };

  if (!unauthorized && token != null) {
    return (
      <>
        <HeaderLogo />

        <Grid className={classes.containerTitle}>
          <Typography className={classes.title}>{'Cambio de contraseña'}</Typography>
          <Typography className={classes.description}>{'Ingrese una nueva contraseña'}</Typography>
        </Grid>

        <Grid className={classes.containerForm}>
          <PasswordForm
            email={emailToResetPassword}
            buttonText={'Guardar cambios e iniciar sesión'}
            onSubmit={onSubmit}
            onError={onError}
            showInputError={showInputError}
          />

          {showAlert && (
            <Grid className={classes.containerAlert}>
              <SimpleAlert fullWidth text={alertMessage} type={alertType} />
            </Grid>
          )}
        </Grid>

        <Grid className={classes.containerForm}>
          <HelpSection />
        </Grid>

        <DevelopedBySection />
      </>
    );
  } else if (unauthorized) {
    return (
      <TokenNotValidForm
        infoText="Si deseas realizar la solicitud nuevamente, haz click en el botón 'Volver a recuperar contraseña'."
        buttonText="Volver a recuperar contraseña"
        buttonPathName={RESET_PASSWORD}
      />
    );
  } else {
    return <Redirect to={LOGIN} />;
  }
};

export default ChangePasswordForm;
